import { getPromos } from './getPromos';
import { IPromo } from '../../types/newbuilding/promos';
import { IApplicationState } from '../../types/redux';

export function getPromo(state: IApplicationState): IPromo | undefined {
  return getPromos(state)[0];
}
